module.exports = __webpack_public_path__ + "static/media/SourceSansPro-LightIt.120d8aec.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-LightIt.woff
// module id = 329
// module chunks = 3